module.exports = __webpack_public_path__ + "static/media/semitendinosus_right_weak.8771ed8c.png";